import React, { useState, useEffect } from "react";
import style from "./Content.module.css";
import announcement from "../../assets/images/slidesmobile/announcement.svg";
import claimBlue from "../../assets/images/stuff/claimBlue.png";
import claimed from "../../assets/images/stuff/claimed.png";
import lpBlue from "../../assets/images/stuff/lpBlue.svg";
import lpOrange from "../../assets/images/stuff/lpOrange.svg";
import newgoodies from "../../assets/images/stuff/newgoodies.svg";
import allContent from "../../allContent";

import VideoSlide from "../VideoSlide/VideoSlide";
import CalimButton from "../ClaimButton/CalimButton";

const Content = ({
  item,
  index,
  phase,
  setPhase,
  setOpenVideo,
  setVideo,
  setShowDialog,
  setDialogContent,
}) => {
  const [contentStyle, setContentStyle] = useState(null);
  const [firstStateOfPhase, setFirstStateOfPhase] = useState(0);
  // const [seen, setSeen] = useState(false);

  const today = new Date();
  const todayTimestamp = today.getTime();

  useEffect(() => {
    if (firstStateOfPhase === 0) {
      setContentStyle(style.content);
    }
    if (phase === 0 && firstStateOfPhase === 0) {
      setContentStyle(style.content);
      setFirstStateOfPhase(1);
    }
    if (phase === 1 && firstStateOfPhase !== 0) {
      setContentStyle(style.contentShowAll);
    }
    if (phase > 1 && index + 2 === phase && firstStateOfPhase !== 0) {
      setContentStyle(style.contentShowOne);
    }
    if (phase > 1 && index + 2 > phase && firstStateOfPhase !== 0) {
      setContentStyle(style.contentMinimazed);
    }
    if (phase > 1 && index + 2 < phase && firstStateOfPhase !== 0) {
      setContentStyle(style.contentShrinked);
    }
    if (phase === 0 && firstStateOfPhase !== 0) {
      setContentStyle(style.contentMinimazed);
    }
  }, [phase]);
  return (
    <div className={contentStyle}>
      <div
        className={style.contentBg}
        style={{
          opacity:
            index + 2 === phase && todayTimestamp > item.timestamp ? "1" : "0",
        }}
      ></div>
      <div
        className={style.contentHeader}
        style={{
          opacity: todayTimestamp < item.timestamp ? "0.3" : "0.99",
        }}
        onPointerUp={() => {
          setPhase(index + 2);
        }}
      >
        <div className={style.contentHeaderText}>
          <div className={style.contentHeaderEpisode}>{item.episode}</div>
          <div className={style.contentHeaderTitle}>{item.title}</div>
        </div>
        <div className={style.contentHeaderImages}>
          <img src={item.stickers[0]} alt="sticker" width={"58px"} />
          <div
            className={
              todayTimestamp > item.timestamp
                ? style.contentHeaderWeek
                : style.contentHeaderWeekDark
            }
          >
            <div
              className={style.blueGradient}
              style={{
                opacity: item.seen ? "0" : "0.99",
              }}
            ></div>
            <div
              className={style.yellowGradient}
              style={{
                opacity: !item.seen ? "0" : "0.99",
              }}
            ></div>
            <div
              className={style.silverGradient}
              style={{
                opacity: todayTimestamp > item.timestamp ? "0" : "0.99",
              }}
            ></div>
            <span>{index + 1}</span>
            <p>{allContent.week}</p>
          </div>
        </div>
      </div>
      <div
        className={style.slider}
        style={{
          opacity: todayTimestamp < item.timestamp ? "0.3" : "0.99",
        }}
      >
        {item.videos.map((video, index) => {
          return (
            <VideoSlide
              key={index}
              video={video}
              setOpenVideo={setOpenVideo}
              setVideo={setVideo}
              phase={phase}
              todayTimestamp={todayTimestamp}
              timestamp={item.timestamp}
            />
          );
        })}
        {item.episode !== allContent.week4.episode && (
          // <img src={announcement} alt="announcement" />
          <img src={allContent.main.announcement} alt="announcement" />
        )}
      </div>
      <div
        className={style.text}
        style={{
          opacity: todayTimestamp < item.timestamp ? "0.3" : "0.99",
          marginTop: item.seen ? "0px" : "12px",
        }}
      >
        {item.text}
      </div>
      <div>
        <div
          className={style.slider2}
          style={{
            opacity: todayTimestamp < item.timestamp ? "0.99" : "0.99",
          }}
        >
          {!item.seen && (
            <>
              <div className={style.placeholder1}>
                <svg
                  viewBox="0 0 151 151"
                  preserveAspectRatio="none"
                  fill="none"
                  stroke="#00000033"
                  strokeWidth="2"
                  strokeDasharray="9,8"
                  style={{ width: "100%", height: "100%" }}
                >
                  <rect x="2" y="2" width="146" height="146" rx="25" />
                </svg>
                <div className={style.imageWrapper}>
                  <img src={item.placeholders[1]} alt="placeholder" />
                </div>
              </div>
              <div className={style.placeholder1}>
                <svg
                  viewBox="0 0 151 151"
                  preserveAspectRatio="none"
                  fill="none"
                  stroke="#00000033"
                  strokeWidth="2"
                  strokeDasharray="9,8"
                  style={{ width: "100%", height: "100%" }}
                >
                  <rect x="2" y="2" width="146" height="146" rx="25" />
                </svg>
                <div className={style.imageWrapper}>
                  <p style={{
                    width: "80%",
                    margin: "auto",
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: "14px",
                    color: "#00000033",
                  }}>
                    {index < 3 ? allContent.main.watch : allContent.main.watch2}
                  </p>
                  {/* <img src={item.placeholders[1]} alt="placeholder" /> */}
                </div>
              </div>
              
              {/* <div key={index} className={style.placeholder}>
                <img src={item.placeholders[0]} alt="placeholder" />
              </div> */}
            </>
          )}
          {item.seen && (
            <>
              <div className={style.icons}>
                <img
                  src={item.stickers[0]}
                  alt="icons"
                  className={style.sticker}
                />
                {/* <img
                  src={claimBlue}
                  alt="claimBlue"
                  className={style.claim}
                  onPointerUp={() => {
                    setShowDialog(true);
                    setDialogContent({
                      type: "sticker",
                      stickers: item.stickers,
                    });
                  }}
                  id={item.claimId}
                /> */}
                <CalimButton
                  item={item}
                  setShowDialog={setShowDialog}
                  setDialogContent={setDialogContent}
                  style={style}
                />
              </div>
              {item.posters.map((poster, index) => {
                return (
                  <div style={{ position: "relative" }} key={index}>
                    <img
                      src={poster.url}
                      alt="meme"
                      id={poster.memeId}
                      key={index}
                      className={style.meme}
                      preload="metadata"
                    />
                    <div
                      style={{
                        position: "absolute",
                        top: "0",
                        left: "0",
                        bottom: "0",
                        right: "0",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        background: !poster.seen
                          ? "rgba(0,0,0,0.5)"
                          : "rgba(0,0,0,0.0)",
                        transition: "all 0.3s ease",
                        borderRadius: "30px",
                      }}
                      onPointerUp={() => {
                        setShowDialog(true);
                        setDialogContent({
                          type: "meme",
                          meme: item.memes[index],
                        });
                        poster.setSeen(true);
                      }}
                    >
                      {!poster.seen && (
                        <span
                          style={{
                            color: "white",
                            fontSize: "1.2rem",
                            textAlign: "center",
                          }}
                        >
                          {allContent.clickToOpen
                            .split("\n")
                            .map((line, index) => (
                              <React.Fragment key={index}>
                                {line}
                                <br />
                              </React.Fragment>
                            ))}
                        </span>
                      )}
                    </div>
                    <img
                      src={poster.seen ? lpOrange : lpBlue}
                      alt="lp"
                      style={{
                        position: "absolute",
                        right: "0",
                        bottom: "0",
                        transform: "translate(-20%, -20%)",
                        width: "40px",
                      }}
                    />
                  </div>
                );
              })}
              {item.episode !== allContent.week4.episode && (
                <img
                  // src={newgoodies}
                  src={allContent.main.newGoodies}
                  alt="newgoodies"
                  className={style.newgoodies}
                />
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Content;
